// eslint-disable-next-line
import React from 'react' // Needed for styled() Extends

import styled from 'styled-components'
const tabletWidth = 1200
const mobileWidth = 980
export const Layout = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  [data-type='underline'] {
    width: 120px;
    height: 2px;
    background: #333333;
    margin-bottom: 40px;
    margin-top: 16px;
  }
  [data-type='subtitle'] {
    color: #333;
    font-size: 44px;
    font-style: normal;
    font-weight: 400;
    line-height: 44px;
  }
  [data-type='text'] {
    color: #333;
    font-size: 22px;
    font-style: normal;
    font-weight: 400;
  }
  [data-type='text-section'] {
    max-width: 580px;
  }
  [data-type='contact-us-button'] {
    width: 260px;
    height: 60px;
    background: none;
    color: #333333;
    font-size: 18px;
    font-style: normal;
    font-weight: 600;
    line-height: 28px;
    letter-spacing: 0.9px;
    border: 1px solid #333333;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    &[data-style='hero'] {
      color: #ffffff;
      border: 1px solid #ffffff;
      @media (max-width: ${mobileWidth}px) {
        width: 100%;
        max-width: none;
        margin-bottom: 40px;
        height: 44px;
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 12px;
        font-style: normal;
        font-weight: 600;
        line-height: 28px; /* 233.333% */
        letter-spacing: 1.92px;
      }
    }
  }
  [data-section='services'] {
    display: flex;
    flex-direction: column;
    margin: 80px 0;
    [data-type='subtitle'] {
      margin-top: 0;
      margin-bottom: 32px;
      align-self: center;
    }
    [data-type='item-row'] {
      display: flex;
      flex-direction: row;
      justify-content: center;
      overflow-x: scroll;
      [data-type='item'] {
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-right: 34px;
        text-decoration: none;
        &:first-child {
          margin-left: 48px;
        }
        &:last-child {
          margin-right: 48px;
        }
        p {
          margin: 0;
          margin-top: 12px;
          color: #333333;
          text-align: center;
          font-size: 14px;
          font-style: normal;
          font-weight: 600;
          line-height: 28px;
          letter-spacing: 2.24px;
          text-transform: uppercase;
          text-decoration: none;
        }
      }
    }
  }
  [data-section='benefit'] {
    display: flex;
    padding: 80px 48px;
    flex-direction: row;
    background: #f9f9f9;
    //justify-content: space-between;
    [data-type='image'] {
      align-self: center;
      img {
        object-fit: cover;
        object-position: center center;
      }
    }
    [data-type='text-section'] {
      margin-left: 118px;
      display: flex;
      flex-direction: column;
      justify-content: center;
    }
    [data-type='subtitle'] {
      margin: 0;
      //margin-bottom: 52px;
    }
    [data-type='contact-us'] {
      width: 100%;
    }
    [data-type='contact-us-button'] {
      margin-left: 20px;
    }
    ul {
      margin-top: 0;
      margin-bottom: 47px;
      li {
        color: #333333;
        font-size: 22px;
        font-style: normal;
        font-weight: 400;
        line-height: 36px;
      }
    }
  }
  [data-section='process'] {
    margin: 80px 0;
    display: flex;
    flex-direction: column;
    &[data-style='capability'] {
      background: #f9f9f9;
      margin: 0;
      padding: 80px 0;
    }
    [data-type='subtitle'] {
      margin: 0;
      align-self: center;
    }
    [data-type='description'] {
      color: #333333;
      text-align: center;
      font-size: 22px;
      font-style: normal;
      font-weight: 400;
      line-height: 32px;
      max-width: 680px;
      width: 100%;
      display: flex;
      align-self: center;
      margin: 40px 0;
    }
    [data-type='explore-capabilities-link'] {
      max-width: 420px;
      width: 100%;
      height: 60px;
      background: #262626;
      margin-top: 80px;
      display: flex;
      align-self: center;
      justify-content: center;
      align-items: center;
      color: #ffffff;
      text-decoration: none;
      text-align: center;
      font-size: 18px;
      font-style: normal;
      font-weight: 600;
      line-height: 28px;
      letter-spacing: 0.9px;
    }
    [data-type='item-row'] {
      display: flex;
      flex-direction: row;
      justify-content: center;
      overflow-x: scroll;
      [data-type='item'] {
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-right: 34px;
        text-decoration: none;
        &:first-child {
          margin-left: 48px;
        }
        &:last-child {
          margin-right: 48px;
        }
        p {
          margin: 0;
          margin-bottom: 15px;
          color: #333333;
          text-align: center;
          font-size: 18px;
          font-style: normal;
          font-weight: 500;
          line-height: 28px;
          letter-spacing: 2.88px;
        }
      }
    }
  }
  [data-section='emerging-artists'] {
    display: flex;
    padding: 80px 0 80px 100px;
    flex-direction: row;
    background: #f9f9f9;
    //justify-content: space-between;
    [data-type='image'] {
      align-self: center;
      img {
        object-fit: cover;
        object-position: center center;
      }
    }
    [data-type='text-section'] {
      margin-right: 107px;
      display: flex;
      flex-direction: column;
      justify-content: center;
    }
    [data-type='subtitle'] {
      margin: 0;
      //margin-bottom: 52px;
    }
    [data-type='description'] {
      color: #333333;
      font-size: 22px;
      font-style: normal;
      font-weight: 400;
      line-height: 36px;
      margin: 0;
    }
    ul {
      li {
        color: #333333;
        font-size: 22px;
        font-style: normal;
        font-weight: 400;
        line-height: 36px;
      }
    }
  }
  [data-section='case-study-carousel'] {
    padding: 100px 0 100px 51px;
    display: flex;
    flex-direction: row;
    [data-type='slideshow'] {
      overflow: hidden;
      width: 692px;
      [data-type='slider'] {
        white-space: nowrap;
        [data-type='slide'] {
          display: inline-block;
          opacity: 0.3;
          transition: opacity 0.7s ease-in-out;
          width: 100%;
          position: relative;
          img {
            object-fit: cover;
            object-position: top center;
          }
          &[data-style='active'] {
            opacity: 1;
          }
        }
      }
    }
    [data-type='text-section'] {
      //max-width: 300px;
      margin-left: 115px;
      align-self: center;
      [data-type='subtitle'] {
        margin: 0;
        margin-bottom: 60px;
        line-height: 50px;
      }
      [data-type='subtitle'] {
        margin: 0;
        margin-bottom: 10px;
      }
      [data-type='explore-link'] {
        height: 60px;
        max-width: 305px;
        width: 100%;
        display: flex;
        border: 1px solid #333333;
        text-decoration: none;
        text-align: center;
        justify-content: center;
        align-items: center;
        color: #333333;
        font-size: 18px;
        font-style: normal;
        font-weight: 600;
        line-height: 28px;
        letter-spacing: 0.9px;
        margin-top: 50px;
      }
    }
  }
  [data-section='client-carousel'] {
    padding: 0px 70px 160px 70px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    [data-type='subtitle'] {
      margin: 0;
      margin-bottom: 60px;
    }
    [data-type='dots'] {
      text-align: center;
      margin-top: 20px;
      [data-type='dot'] {
        display: inline-block;
        height: 12px;
        width: 12px;
        border-radius: 50%;
        cursor: pointer;
        margin: 15px 7px 0px;
        background: rgba(153, 153, 153, 0.5);
        &[data-style='active'] {
          background: #999;
        }
      }
    }
    [data-type='slideshow'] {
      overflow: hidden;
      width: 100%;
      [data-type='slider'] {
        white-space: nowrap;
        [data-type='slide'] {
          display: inline-block;
          opacity: 0.3;
          transition: opacity 0.7s ease-in-out;
          width: 100%;
          position: relative;
          &[data-style='active'] {
            opacity: 1;
          }
          [data-type='wrapper'] {
            display: flex;
            flex-direction: row;
            margin-left: auto;
            margin-right: auto;
            max-width: 1285px;
            flex-wrap: wrap;
            justify-content: center;
            align-items: center;
          }
        }
      }
    }
  }
  [data-section='aa-services'] {
    display: flex;
    padding: 80px 48px;
    flex-direction: row;
    //background: #f9f9f9;
    //justify-content: space-between;
    [data-type='image'] {
      align-self: center;
    }
    [data-type='text-section'] {
      margin-left: 118px;
      display: flex;
      flex-direction: column;
      justify-content: center;
    }
    [data-type='subtitle'] {
      margin: 0;
      //margin-bottom: 52px;
    }
    [data-type='contact-us'] {
      width: 100%;
    }
    [data-type='contact-us-button'] {
      margin-left: 7px;
    }
    ul {
      margin-top: 0;
      margin-bottom: 47px;
      padding-left: 25px;
      li {
        color: #333333;
        font-size: 22px;
        font-style: normal;
        font-weight: 400;
        line-height: 36px;
      }
    }
  }
  [data-section='awards-press'] {
    display: flex;
    margin: 60px 0;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    [data-type='subtitle'] {
      margin: 0;
      align-self: center;
    }
    [data-type='description'] {
      color: #333;
      text-align: center;
      font-size: 22px;
      font-style: normal;
      font-weight: 400;
      line-height: 32px;
      width: 100%;
      max-width: 794px;
      display: flex;
      align-self: center;
      margin-bottom: 0;
    }
    [data-type='award'] {
      display: flex;
      flex-direction: row;
      padding: 80px 50px 50px 60px;
      &[data-style='image-first'] {
        padding: 60px 50px;
        [data-type='text'] {
          margin-left: 115px;
          margin-right: 0;
        }
      }
      [data-type='text'] {
        margin-right: 115px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        [data-type='award-name'] {
          color: #333;
          font-size: 14px;
          font-style: normal;
          font-weight: 600;
          line-height: 28px;
          letter-spacing: 2.24px;
          text-transform: uppercase;
          margin: 0;
          text-align: center;
        }
        [data-type='hotel-name'] {
          color: #333;
          text-align: center;
          font-size: 44px;
          font-style: normal;
          font-weight: 400;
          line-height: 50px;
          margin: 5px 0;
          text-align: center;
        }
        [data-type='location'] {
          margin-top: 0;
          color: #333;
          text-align: center;
          font-size: 44px;
          font-style: normal;
          font-weight: 400;
          line-height: 50px;
          margin-bottom: 5px;
          text-align: center;
        }
        [data-type='award-title'] {
          margin: 0;
          color: #333;
          text-align: center;
          font-size: 18px;
          font-style: normal;
          font-weight: 400;
          line-height: 30px;
          text-align: center;
        }
      }
    }
    [data-type='press'] {
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      padding: 60px 50px;
      &[data-style='image-first'] {
        [data-type='text-section'] {
          margin-left: 80px;
          margin-right: 0;
        }
      }
      [data-type='text-section'] {
        display: flex;
        flex-direction: column;
        margin-right: 80px;
        [data-type='text'] {
          &[data-style='additional-text'] {
            margin-top: 40px;
          }
          [data-type='quote'] {
            color: #333;
            text-align: center;
            font-size: 28px;
            font-style: italic;
            font-weight: 400;
            line-height: 35px;
            width: 100%;
            margin: 0;
          }
          [data-type='press-name'] {
            margin-top: 16px;
            margin-bottom: 0px;
            color: #333;
            text-align: center;
            font-size: 14px;
            font-style: normal;
            font-weight: 600;
            line-height: 28px;
            letter-spacing: 2.24px;
            text-transform: uppercase;
          }
          [data-type='location'] {
            color: #333;
            text-align: center;
            font-size: 14px;
            font-style: normal;
            font-weight: 400;
            line-height: 28px;
            margin: 0;
          }
        }
      }
    }
  }
  @media (max-width: ${tabletWidth}px) {
    [data-type='underline'] {
      margin-bottom: 36px;
    }
    [data-section='benefit'] {
      padding: 80px 28px;
      justify-content: center;
      align-items: center;
      ul {
        align-self: flex-start;
      }
      [data-type='image'] {
        width: 433px;
        height: 434px;
      }
    }
    [data-section='services'] {
      [data-type='item-row'] {
        justify-content: flex-start;
      }
    }
    [data-section='process'] {
      [data-type='item-row'] {
        justify-content: flex-start;
      }
    }
    [data-section='emerging-artists'] {
      padding: 80px 0 80px 62px;
      justify-content: center;
      align-items: center;
      [data-type='image'] {
        width: 494px;
        height: 581px;
      }
    }
    [data-section='case-study-carousel'] {
      padding: 80px 0 80px 0;
      [data-type='slideshow'] {
        width: 568px;
        height: 379px;
        [data-type='slide'] {
          img {
            width: 568px;
            height: 379px;
          }
        }
      }
      [data-type='text-section'] {
        margin-left: 100px;
      }
    }
    [data-section='aa-services'] {
      padding: 80px 28px;
      justify-content: center;
      align-items: center;
      ul {
        align-self: flex-start;
      }
      [data-type='image'] {
        width: 433px;
        height: 434px;
      }
    }
    [data-section='awards-press'] {
      padding: 60px 28px;
      justify-content: center;
      align-items: center;
      [data-type='image'] {
        width: 568px;
        height: 379px;
      }
    }
  }
  @media (max-width: ${mobileWidth}px) {
    [data-type='underline'] {
      align-self: flex-start;
      margin-bottom: 24px;
      width: 80px;
    }
    [data-type='subtitle'] {
      color: #333;
      text-align: center;
      font-size: 30px;
      font-style: normal;
      font-weight: 400;
      line-height: 34px;
    }
    [data-type='text'] {
      color: #333;
      text-align: center;
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: 20px;
    }
    [data-section='services'] {
      margin: 40px 0;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      [data-type='subtitle'] {
        text-align: center;
      }
      [data-type='item-row'] {
        display: flex;
        flex-direction: column;
        [data-type='item'] {
          margin: 0;
          margin-bottom: 36px;
          &:first-child {
            margin-left: 0;
          }
          &:last-child {
            margin-right: 0;
            margin-bottom: 20px;
          }
          p {
            margin-top: 0;
          }
          [data-type='image'] {
            width: 100%;
            height: 340px;
          }
        }
      }
    }
    [data-section='benefit'] {
      padding: 0;
      display: flex;
      flex-direction: column;
      [data-type='subtitle'] {
        text-align: left;
        //margin-bottom: 24px;
      }
      [data-type='image'] {
        width: 100%;
        height: 250px;
      }
      [data-type='text-section'] {
        padding: 40px 16px;
        margin: 0;
        align-items: center;
      }
      [data-type='contact-us-button'] {
        margin-left: 0;
        width: 100%;
        text-align: center;
        font-size: 12px;
        font-style: normal;
        font-weight: 600;
        line-height: 28px;
        letter-spacing: 1.92px;
      }
      ul {
        padding-left: 20px;
        li {
          color: #333;
          font-size: 14px;
          font-style: normal;
          font-weight: 400;
          line-height: 22px;
          margin-bottom: 10px;
        }
      }
    }
    [data-section='process'] {
      margin: 40px 16px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      &[data-style='capability'] {
        padding: 60px 16px;
      }
      [data-type='subtitle'] {
        text-align: center;
      }
      [data-type='description'] {
        margin-top: 16px;
        margin-bottom: 24px;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 20px;
      }
      [data-type='explore-capabilities-link'] {
        margin-top: 48px;
        width: 100%;
        max-width: none;
      }
      [data-type='item-row'] {
        display: flex;
        flex-direction: column;
        [data-type='item'] {
          margin: 0;
          margin-bottom: 36px;
          &:first-child {
            margin-left: 0;
          }
          &:last-child {
            margin-right: 0;
            margin-bottom: 20px;
          }
          p {
            margin-top: 0;
            margin-bottom: 15px;
            color: #333;
            text-align: center;
            font-size: 18px;
            font-style: normal;
            font-weight: 500;
            line-height: 28px;
            letter-spacing: 2.88px;
          }
          [data-type='image'] {
            width: 100%;
            height: 340px;
          }
        }
      }
    }
    [data-section='emerging-artists'] {
      padding: 0;
      margin-top: 40px;
      display: flex;
      flex-direction: column-reverse;
      [data-type='subtitle'] {
        text-align: left;
        //margin-bottom: 24px;
      }
      [data-type='description'] {
        margin: 0;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 20px;
      }
      [data-type='image'] {
        width: 100%;
        height: 250px;
      }
      [data-type='text-section'] {
        padding: 40px 16px;
        margin: 0;
        align-items: center;
      }
      [data-type='contact-us-button'] {
        margin-left: 0;
        width: 100%;
        text-align: center;
        font-size: 12px;
        font-style: normal;
        font-weight: 600;
        line-height: 28px;
        letter-spacing: 1.92px;
      }
      ul {
        padding-left: 20px;
        margin-bottom: 0;
        li {
          color: #333;
          font-size: 14px;
          font-style: normal;
          font-weight: 400;
          line-height: 22px;
          margin-bottom: 10px;
          &:last-child {
            margin-bottom: 0;
          }
        }
      }
    }
    [data-section='case-study-carousel'] {
      padding: 40px 16px 40px 16px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      [data-type='slideshow'] {
        width: 100%;
        height: 187px;
        [data-type='slide'] {
          img {
            width: 100%;
            height: 187px;
          }
        }
      }
      [data-type='text-section'] {
        margin-left: 0;
        margin-top: 40px;
        width: 100%;
        [data-type='subtitle'] {
          margin: 0;
          margin-bottom: 10px;
          line-height: 32px;
        }
        [data-type='explore-link'] {
          margin-top: 38px;
          width: 100%;
          max-width: none;
        }
      }
    }
    [data-section='client-carousel'] {
      padding: 40px 16px;
      [data-type='subtitle'] {
        margin-bottom: 36px;
      }
      [data-type='slideshow'] {
        [data-type='slider'] {
          [data-type='slide'] {
            [data-type='wrapper'] {
              max-width: 343px;
              [data-type='image'] {
                width: 100px;
                height: 50px;
                &:nth-child(9) {
                  display: none;
                }
              }
            }
          }
        }
      }
      [data-type='dots'] {
        [data-type='dot'] {
          height: 8px;
          width: 8px;
        }
      }
    }
    [data-section='aa-services'] {
      padding: 0;
      display: flex;
      flex-direction: column;
      [data-type='subtitle'] {
        text-align: left;
        //margin-bottom: 24px;
      }
      [data-type='image'] {
        width: 100%;
        height: 250px;
        object-fit: cover;
        object-position: center center;
      }
      [data-type='text-section'] {
        padding: 40px 16px;
        margin: 0;
        align-items: center;
      }
      [data-type='contact-us-button'] {
        margin-left: 0;
        width: 100%;
        text-align: center;
        font-size: 12px;
        font-style: normal;
        font-weight: 600;
        line-height: 28px;
        letter-spacing: 1.92px;
      }
      ul {
        padding-left: 20px;
        li {
          color: #333;
          font-size: 14px;
          font-style: normal;
          font-weight: 400;
          line-height: 22px;
          margin-bottom: 10px;
        }
      }
    }
    [data-section='awards-press'] {
      padding: 60px 16px;
      margin: 0;
      display: flex;
      justify-content: center;
      align-items: center;
      [data-type='description'] {
        color: #333;
        text-align: center;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 20px;
      }
      [data-type='image'] {
        height: 212px;
        width: 100%;
        object-fit: cover;
        object-position: center center;
      }
      [data-type='award'] {
        display: flex;
        flex-direction: column;
        padding: 36px 0;
        width: 100%;
        &[data-style='text-first'] {
          flex-direction: column-reverse;
          [data-type='text'] {
            margin-top: 18px;
            margin-right: 0;
            [data-type='hotel-name'] {
              font-size: 30px;
              font-style: normal;
              font-weight: 400;
              line-height: 40px;
              margin: 0;
            }
            [data-type='award-title'] {
              font-size: 13px;
              font-style: normal;
              font-weight: 400;
              line-height: 40px;
            }
          }
        }
        &[data-style='image-first'] {
          padding: 0;
          [data-type='text'] {
            margin-top: 18px;
            margin-left: 0;
            [data-type='hotel-name'],
            [data-type='location'] {
              font-size: 30px;
              font-style: normal;
              font-weight: 400;
              line-height: 40px;
              margin: 0;
            }
            [data-type='award-title'] {
              font-size: 13px;
              font-style: normal;
              font-weight: 400;
              line-height: 40px;
            }
          }
        }
      }
      [data-type='press'] {
        display: flex;
        flex-direction: column;
        padding: 36px 0;
        &[data-style='text-first'] {
          flex-direction: column-reverse;
          [data-type='text-section'] {
            margin-top: 16px;
            margin-right: 0;
          }
        }
        &[data-style='image-first'] {
          padding-top: 20px;
          [data-type='text-section'] {
            margin-top: 16px;
            margin-left: 0;
          }
        }
        [data-type='text-section'] {
          [data-type='text'] {
            &[data-style='additional-text'] {
              margin-top: 24px;
            }
            [data-type='quote'] {
              color: #333;
              text-align: center;
              font-size: 22px;
              font-style: italic;
              font-weight: 400;
              line-height: 26px;
            }
            [data-type='press-name'] {
              font-size: 14px;
              font-style: normal;
              font-weight: 600;
              line-height: 28px;
              letter-spacing: 2.24px;
              margin-top: 8px;
            }
          }
        }
      }
    }
  }
`